import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Building2, X, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const KEY = "mp_profile_nudge_off";

/** Sign-up asks for 3 fields only: VAT, address and country are collected here. */
export default function CompleteProfileBanner() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [off, setOff] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });

  const incomplete = !!user && (!user.vat_number || !user.address || !user.country);
  if (!incomplete || off) return null;

  const dismiss = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* storage off */ }
    setOff(true);
  };

  return (
    <div className="relative z-30 bg-blue-500/10 border-b border-blue-500/30" data-testid="complete-profile-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-start sm:items-center gap-2.5 text-sm text-blue-200">
          <Building2 size={16} className="mt-0.5 sm:mt-0 shrink-0"/>
          <span>{t("profileBanner.message")}</span>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/settings" className="text-xs px-3 py-1.5 rounded border border-blue-500/50 text-blue-200 hover:bg-blue-500/10 flex items-center gap-1.5"
            data-testid="complete-profile-cta">
            {t("profileBanner.cta")}<ArrowRight size={12}/>
          </Link>
          <button onClick={dismiss} className="text-blue-300/70 hover:text-blue-200 p-1"
            aria-label={t("verifyBanner.close")} data-testid="complete-profile-close">
            <X size={15}/>
          </button>
        </div>
      </div>
    </div>
  );
}
